import React, { Fragment } from 'react'
import { Map } from 'immutable'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import PureDataComponent from '@aytm/lib/common/components/pure-component'
import { stopEvent } from '@aytm/lib/common/func'

import Popup from '@aytm/lib/rfd-ui/components/basic/popup'
import ImagePopup from './image-popup'

import '@aytm/lib/rfd-ui/styles/basic/image-pin.scss'

// const isIFrame = (() => {
//   try {
//     return window.self !== window.top
//     // eslint-disable-next-line no-unused-vars
//   } catch {
//     return true
//   }
// })()

export default class ImagePin extends PureDataComponent {
  static propTypes = {
    baseURL: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    previewURL: PropTypes.string.isRequired,
    thumbnail: PropTypes.instanceOf(Map),
    label: PropTypes.string,
    altText: PropTypes.string,
    zoomIcon: PropTypes.string,
    loadingIcon: PropTypes.string,
    failedIcon: PropTypes.string,
    clickOnZoom: PropTypes.bool,
    centeredZoom: PropTypes.bool,
    withPincher: PropTypes.bool,
    withPopup: PropTypes.bool,
    withZoom: PropTypes.bool,
    scrolling: PropTypes.bool,
    clickOnImage: PropTypes.bool,
    popupOpened: PropTypes.bool,
    mobile: PropTypes.bool,
    onLoad: PropTypes.func,
    onPopup: PropTypes.func,
    onError: PropTypes.func,
    onClick: PropTypes.func,
    onZoomClick: PropTypes.func
  }

  static contextTypes = {
    popup: PropTypes.instanceOf(Popup)
  }

  constructor(props) {
    super(props)
    this.clickImage = this.clickImage.bind(this)
    this.popupOpened = this.popupOpened.bind(this)
    this.imageLoad = this.imageLoad.bind(this)
    this.imageError = this.imageError.bind(this)
    this.doChangeStateHandler = {}
    this.state = {
      loading: true,
      loaded: false,
      popup: props.popupOpened || false
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.popupOpened != nextProps.popupOpened) this.setState({ popup: nextProps.popupOpened })
  }

  doChangeState(id, change, zoom) {
    const that = this
    const { onClick, onZoomClick } = this.props
    // if ('function' == typeof onClick) {
    //   // onClick()
    //   return onClick
    // } else {
    return (
      this.doChangeStateHandler[id] ||
      (this.doChangeStateHandler[id] = event => {
        stopEvent(event)
        // if ('function' == typeof onClick) onClick()
        if (onZoomClick && zoom && 'function' == typeof onZoomClick) onZoomClick(change.popup)
        if (change.popup) {
          const { popup } = this.context
          if (popup) {
            popup.hide()
          } else {
            if ('function' == typeof onClick) onClick()
          }
        }
        that.setState(change)
        return false
      })
    )
    // }
  }

  clickImage() {
    if (!this.state.loaded) return false
    const { onClick } = this.props
    if ('function' == typeof onClick) {
      onClick()
    }
    return true
  }

  popupOpened() {
    setTimeout(() => {
      const { onPopup } = this.props
      'function' == typeof onPopup && onPopup()
    }, 10)
  }

  imageLoad(callback) {
    callback &&
      setTimeout(() => {
        const { onLoad } = this.props
        'function' == typeof onLoad && onLoad()
      }, 10)

    this.setState({ loading: false, loaded: true })
  }

  imageError() {
    const { onError } = this.props
    'function' == typeof onError && onError()

    this.setState({ loading: false, loaded: false })
  }

  render() {
    const {
      baseURL,
      previewURL,
      width,
      label,
      altText,
      clickOnZoom,
      // onClick,
      withPopup,
      withZoom,
      hasLoaded,
      thumbnail,
      popupOpened,
      mobile,
      clickOnImage,
      closeOnClick = true,
      withPincher
    } = this.props
    const { loading, loaded, popup } = this.state
    const zoomIcon = this.props.zoomIcon || 'icon-aytmfd-zoom-in'
    const loadingIcon = this.props.loadingIcon || 'icon-aytmfd-spin aytmfd-spin'
    const failedIcon = this.props.failedIcon || 'icon-aytmfd-delete'
    const scrolling = this.props.scrolling || false
    const proportion = thumbnail ? thumbnail.get('width') / thumbnail.get('height') : 1
    const showPreloader = thumbnail && thumbnail.get('width') > 30 && thumbnail.get('height') > 30
    const supportThumbnail = thumbnail && thumbnail.get('src')
    const showThumbnail = !hasLoaded && thumbnail && thumbnail.get('src')

    const isPincherSupport = false
    const isPincherActive = isPincherSupport && withPincher
    const isPopupActive = popupOpened || (withPopup && !isPincherActive)
    const isZoomActive = withZoom && !isPincherActive

    return (
      <div
        className={classNames('rfd-ui-image-pin', {
          'rfd-ui-image-pin-loading-thumbnail': supportThumbnail && showThumbnail,
          'rfd-ui-image-pin-loaded-thumbnail': supportThumbnail && !showThumbnail,
          'rfd-ui-image-pin-loading': loading,
          'rfd-ui-image-pin-mobile': mobile,
          'rfd-ui-image-pin-loaded': loaded
        })}
        ref={this.saveRef('PinRoot')}
        style={{ width }}
        onClick={this.clickImage}
      >
        {supportThumbnail ? (
          <div
            className="thumbnailDiv"
            style={{
              width: !thumbnail.get('fitToWidth')
                ? thumbnail.get('fitToHeight')
                  ? 'auto'
                  : proportion > 1
                    ? '100%'
                    : proportion * 100 + '%'
                : 'auto',
              height: thumbnail.get('fitToHeight') ? thumbnail.get('fitToHeight') : 'auto',
              maxWidth: thumbnail.get('width'),
              maxHeight: thumbnail.get('height')
            }}
          >
            <img
              // data-pincher={isPincherActive ? true : undefined}
              width={width}
              src={previewURL}
              ref={this.saveRef('Image')}
              onLoad={this.imageLoad}
              onError={this.imageError}
              style={{ opacity: showThumbnail ? 0 : 1 }}
              className="preview"
              data-testid="SW-Image"
              alt={altText || ''}
            />
            {showPreloader && showThumbnail && <i className="preloader icon-aytmfd-spin afd-spin"></i>}
            <img
              style={{
                opacity: !showThumbnail ? 0 : 1,
                zIndex: !showThumbnail ? -1 : 0
              }}
              className="thumbnail"
              src={thumbnail.get('src')}
              ref={this.saveRef('Image')}
              onLoad={() => this.imageLoad(false)}
              data-testid="SW-Image-Thumbnail"
              alt=""
              role="presentation"
            />
          </div>
        ) : (
          <img
            data-pincher={isPincherActive ? true : undefined}
            src={isPincherActive ? baseURL : previewURL}
            ref={this.saveRef('Image')}
            onLoad={this.imageLoad}
            onError={this.imageError}
            data-testid="SW-Image"
            alt={altText || ''}
          />
        )}
        {!showThumbnail && loaded ? (
          <Fragment>
            {isPopupActive ? (
              <Fragment>
                {clickOnZoom !== false ? (
                  <div className={'rfd-ui-image-pin-zoom rfd-ui-image-pin-zoom-top-right'}>
                    <i
                      className={`${zoomIcon} ${clickOnImage ? 'fullWidth' : ''} rfd-ui-image-pin-zoom-button`}
                      onClick={this.doChangeState('ps', { popup: true }, true)}
                    />
                  </div>
                ) : null}
                <ImagePopup
                  scrolling={scrolling}
                  imageProps={{
                    'data-pincher': isPincherSupport ? true : undefined
                  }}
                  src={baseURL}
                  label={label}
                  altText={altText}
                  show={popup}
                  loadingIcon={loadingIcon}
                  failedIcon={failedIcon}
                  closeOnClick={closeOnClick}
                  closeIcon={failedIcon}
                  onLoad={this.popupOpened}
                  onClose={this.doChangeState('ph', { popup: false }, true)}
                />
              </Fragment>
            ) : isZoomActive ? (
              <div className="rfd-ui-image-pin-zoom rfd-ui-image-pin-zoom-top-left">
                <input type="hidden" value={baseURL} className="preview_image hidden_image" />
                <i className={`${zoomIcon} rfd-ui-image-pin-zoom-button`} />
              </div>
            ) : null}
          </Fragment>
        ) : loading ? (
          <div className="rfd-ui-image-pin-loader">
            <i className={`${loadingIcon}`} />
          </div>
        ) : !showThumbnail ? (
          <div className="rfd-ui-image-pin-failed">
            <i className={failedIcon} />
          </div>
        ) : null}
      </div>
    )
  }
}
